import { FC, useEffect, useState } from 'react';
import Text from '@/components/text';
import Button from '@/components/button';
import Illustration from '@/components/illustration';
import PageCard from '@/components/page-card';
import { LoadState } from '@/lib/helpers';
import { addError } from '@/lib/datadog';
import { getUrlQueryParam } from '@/lib/url-helpers';
import { DEFAULT_ERROR_CONTENT, ErrorContentMap } from './helpers';

interface Props {
  error?: Error;
}

const ErrorPage: FC<Props> = ({ error }) => {
  const code = getUrlQueryParam('code'); // using tanstack useSearch was throwing an error for some reason

  const [loadState, setLoadState] = useState<LoadState>('unloaded');

  useEffect(() => {
    if (!error) {
      setLoadState('loaded');
      return;
    }

    if (loadState !== 'unloaded') {
      return;
    }

    const renderError = new Error(error.message);
    renderError.name = `ReactRenderingError`;
    renderError.stack = error.stack;
    renderError.cause = error;
    addError(renderError);

    setLoadState('loaded');
  }, [loadState, error]);

  const { illustration, title, content, showHomeButton } =
    ErrorContentMap.get(Number(code)) || DEFAULT_ERROR_CONTENT;

  const handleGoHome = () => {
    window.location.href = '/';
  };

  return (
    <PageCard width={700}>
      <Illustration name={illustration} />
      <Text bold size="x-large" color="active">
        {title}
      </Text>
      <Text color="active">{content}</Text>

      {showHomeButton && <Button label="Go back to Homepage" onClick={handleGoHome} />}
    </PageCard>
  );
};

export default ErrorPage;
